// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3g5D3","bigColWidth":"Table_bigColWidth__36KIH","biggerColWidth":"Table_biggerColWidth__2FDIp","row":"Table_row__1fuE2","col":"Table_col__3NzGP"};